import { Component } from "preact";
import { Provider } from "preact-redux";
import configureStore from "../store";
import ReactGA from "react-ga";
import Api from "../lib/api";
import Route from "../routes";

const store = configureStore();

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      someData: null,
    };
    ReactGA.initialize(Api.GA_TRACKING_ID);
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <Provider store={store}>
        <Route />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js